import React from 'react'
import { useServiceScheduleContext } from '../../../context/serviceScheduleContext'
import { formatPrice, getPetPhotoByType } from 'utils'

import * as S from './styles'
import CheckIcon from 'static/icons/check-discount-icon.svg'

const SchedulingInfo = ({ finalStep }) => {
  const {
    state: schedulingState,
    functions
  } = useServiceScheduleContext()

  const {
    pricesInfo
  } = functions

  const {
    activeCampaign,
    schedulingCoupon,
    petsData,
    scheduleBody,
    serviceData,
    selectedPurchasedPackage
  } = schedulingState

  const {
    currentSchedulePrice,
    currentPriceWithDiscount,
    currentHasDiscount,
    priceWithoutPackage
  } = pricesInfo()

  const showDiscount = scheduleBody.selectDay && currentHasDiscount
  const petToRender = petsData.find(pet => pet.id === scheduleBody.pet_id)
  const selectedService = serviceData.find(service => service.value === scheduleBody?.service_id)
  const hasAdditionalServices = scheduleBody?.additional_services.length > 0

  const renderServiceName = () => {
    if (selectedPurchasedPackage) return selectedPurchasedPackage?.service?.name
    return selectedService?.name
  }

  const formattedDiscount = () => {
    const discountType = schedulingCoupon?.discountType || activeCampaign?.discountType
    const discountValue = schedulingCoupon?.discountValue ?? activeCampaign?.discountValue
    return discountType === 'PERCENTAGE' ? `${discountValue}% OFF` : `${formatPrice(discountValue)} OFF`
  }

  function renderPrice () {
    if (finalStep) return null
    if (selectedPurchasedPackage) return null
    if (currentSchedulePrice === 0) return null

    const isPackage = selectedService?.package

    if (isPackage) {
      return (
        <section className='price bath-package'>
          {(currentSchedulePrice > 0) &&
            <S.Price previousPrice={showDiscount} price isPackage>
              <CheckIcon /> De {formatPrice(priceWithoutPackage)} por <span>{formatPrice(currentSchedulePrice)}</span>
            </S.Price>}
        </section>
      )
    }

    return (
      <section className='price'>
        {(currentSchedulePrice > 0) && (
          <S.Price previousPrice={showDiscount} price>{formatPrice(currentSchedulePrice)}</S.Price>
        )}
        {(showDiscount) && (
          <S.Price price>
            {formatPrice(currentPriceWithDiscount)}
          </S.Price>
        )}
      </section>
    )
  }

  return (
    <S.CardContainer>
      <S.StickyCard active>
        <S.Summary title={`Agendamento de ${petToRender?.name}`} isPackage={selectedService?.package}>
          <div>
            <S.PhotoContainer
              src={petToRender?.photo || getPetPhotoByType(petToRender?.breed?.type)}
              alt={petToRender?.name}
              setDefaultPhoto={!petToRender?.photo}
            />
            <section className='pet-info'>
              <p className='pet-name'>{petToRender?.name}</p>
              <p className='service-name'>{renderServiceName()} {hasAdditionalServices && '+ Serviços adicionais'}</p>
            </section>
          </div>
          {!!scheduleBody.partner_id && (
            renderPrice()
          )}

        </S.Summary>
        {(!finalStep && showDiscount) && (
          <S.DiscountAmount>
            <CheckIcon />
            {`Desconto aplicado ${formattedDiscount()}`}
          </S.DiscountAmount>
        )}
      </S.StickyCard>
    </S.CardContainer>
  )
}

export default SchedulingInfo
